import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    formId: String,
    fieldName: { type: String, default: "selected_address_id" },
  };

  submit() {
    const form = document.getElementById(this.formIdValue);

    if (!form) {
      console.error(`Form with id "${this.formIdValue}" not found`);
      return;
    }

    // Use requestSubmit() to properly trigger form submission
    // Turbo will intercept this and handle it with morphing
    form.requestSubmit();
  }

  submitWithValue(event) {
    const form = document.getElementById(this.formIdValue);

    if (!form) {
      console.error(`Form with id "${this.formIdValue}" not found`);
      return;
    }

    // Update the hidden field with the new value
    const hiddenField = form.querySelector(
      `input[name="${this.fieldNameValue}"]`
    );
    if (hiddenField) {
      hiddenField.value = event.target.value;
    }

    // Submit the form
    form.requestSubmit();
  }
}
